import { useCabinetMemberMe } from '@/hooks/useCabinetMemberMe';

/**
 * Returns whether the current user is a Hector super-admin.
 *
 * Reads platform_role from the centralized useCabinetMemberMe cache — no extra
 * fetch. platform_role === 'hector_super_admin' is set server-side in the
 * public.users table (migration 057) and replaces the old user_metadata.is_admin /
 * user_metadata.is_super_admin JWT-claim approach.
 *
 * Returns a plain boolean (not a useQuery shape) because all callers only need
 * the boolean value and the data is already in the global cache.
 */
export const useSuperAdmin = () => {
  const { data } = useCabinetMemberMe();
  return data?.platform_role === 'hector_super_admin';
};
